import axios from "axios";
import Modal from "react-modal";
import moment from "moment-timezone";
import subDays from "date-fns/subDays";
import { toast } from "react-toastify";
import { DatePicker } from "rsuite";
import { useQuery } from "react-query";
import { AES, enc } from "crypto-js";
import "./expenseOverview.css";
import { ThreeDots } from "react-loader-spinner";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import React, { useState, useEffect, useRef } from "react";
import Currencies from "../../constants/currenciesList.js";
import { logout, reset } from "../../features/auth/authSlice";
import dletImage from "../../images/singleinvoice/delete.svg";
import cancelImage from "../../images/singleinvoice/cancel.svg";
import addicoplus from "../../images/singleinvoice/plus-add-icon.svg";
import crssrImage from "../../images/singleinvoice/cross-red.svg";
import { reset as invoiceReset } from "../../features/invoice/invoiceSlice.js";
import { reset as headerReset, setHeaderText } from "../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset } from "../../features/appSettings/appSettingsSlice.js";
import { useWXCompanies } from "../../components/User/UserDetails/UserProfile/useUserView.jsx";
import { useFetchExpCategory } from "../../components/AppSettings/expenseCategoryApi.jsx";
import { useGetClients, useGetProjects, useGetActiveTeams } from "../../components/TimeTracker/TimeTrackerOverview/useTimeTracker.jsx";
import Close from "../../images/icons/black-close.svg";
import Tick from "../../images/singleinvoice/tick-green.svg";
// import Plus from "../../images/icons/plus.svg";
import { setNotification } from "../../features/notification/notificationSlice.js";

const EditExpense = () => {
    const { encryptedId } = useParams();
    const decodedId = decodeURIComponent(encryptedId.replace(/%2F/g, "/"));
    const decryptedBytes = AES.decrypt(decodedId, "encryptionKey");
    const id = decryptedBytes.toString(enc.Utf8);

    const [expCurrencySearchTerm, setExpCurrencySearchTerm] = useState("");
    const [expCurrencyEditDropdownOpen, setExpCurrencyEditDropdownOpen] = useState(false);
    const [expenseCurrencyEditIsValid, setExpenseCurrencyEditIsValid] = useState(false);
    const [expIsBillableEdit, setExpIsBillableEdit] = useState(true);
    const [isMobile, setIsMobile] = useState(false);
    const [expenseUserEditDropdownOpen, setExpenseUserEditDropdownOpen] = useState(false);
    const [expenseUserEditIsValid, setExpenseUserEditIsValid] = useState(false);
    const expenseUserEditRef = useRef(null);
    const [expenseIdEdit, setExpenseIdEdit] = useState(null);
    const [expenseDateEdit, setExpenseDateEdit] = useState(null);
    const [expenseClientEdit, setExpenseClientEdit] = useState("");
    const [expenseProjectEdit, setExpenseProjectEdit] = useState("");
    const [expenseCompanyEdit, setExpenseCompanyEdit] = useState("");
    const [expNoteEdit, setExpNoteEdit] = useState("");
    const [expFileAttchFilesEdit, setExpFileAttchFilesEdit] = useState([]);
    const [expFileAttchFileNameEdit, setExpFileAttchFileNameEdit] = useState([]);
    const [expFileAttchFileSizeView, setExpFileAttchFileSizeView] = useState([]);
    const [removedFiles, setRemovedFiles] = useState([]);
    const [expProjectEditDropdownOpen, setExpProjectEditDropdownOpen] = useState(false);
    const [expProjectSearchTerm, setExpProjectSearchTerm] = useState("");
    const [expClientEditDropdownOpen, setExpClientEditDropdownOpen] = useState(false);
    const [expenseClientEditIsValid, setExpenseClientEditIsValid] = useState(false);
    const [expenseCompanyEditIsValid, setExpenseCompanyEditIsValid] = useState(false);
    const [expCurrencyList] = useState(Currencies.sourceCurrencies[0].targetCurrencies);
    const [expenseUserEdit, setExpenseUserEdit] = useState("");
    const [expDescriptionEdit, setExpDescriptionEdit] = useState("");
    const [expCurrencyEdit, setExpCurrencyEdit] = useState("");
    const [expSubTotalEdit, setExpSubTotalEdit] = useState("");
    const [expTaxEdit, setExpTaxEdit] = useState("");
    const [expAmountEdit, setExpAmountEdit] = useState(0);
    const [expenseDescriptionEditIsValid, setExpenseDescriptionEditIsValid] = useState(false);
    const [expSubTotalEditIsValid, setExpSubTotalEditIsValid] = useState(false);
    const [expTaxEditIsValid, setExpTaxEditIsValid] = useState(false);
    const [expenseDateEditIsValid, setExpenseDateEditIsValid] = useState(false);
    const [expenseCategoryEditDropdownOpen, setExpenseCategoryEditDropdownOpen] = useState(false);
    const [expenseCategoryEditIsValid, setExpenseCategoryEditIsValid] = useState(false);
    const [expCategoryEdit, setExpCategoryEdit] = useState("");
    const expenseCategoryEditDropdownRef = useRef(null);
    const expenseCategoryEditRef = useRef(null);
    const expenseCurrencyEditRef = useRef(null);
    const expenseCompanyEditRef = useRef(null);
    const [expCompanyEditDropdownOpen, setExpCompanyEditDropdownOpen] = useState(false);
    const [expCompanySearchTerm, setExpCompanySearchTerm] = useState("");
    const [isSubmitLoading, setIsSubmitLoading] = useState(false);
    const [userSearchTerm, setUserSearchTerm] = useState("");
    const [expClientSearchTerm, setExpClientSearchTerm] = useState("");
    const [confirmModalIsOpen, setConfirmModalIsOpen] = useState(false);
    const expenseClientEditDropdownRef = useRef(null);
    const expenseClientEditRef = useRef(null);
    const expenseProjectEditRef = useRef(null);
    const expenseProjectEditDropdownRef = useRef(null);
    const expenseCompanyEditDropdownRef = useRef(null);
    const expenseUserEditSelectDropdownRef = useRef(null);
    const expCurrencyEditDropdownRef = useRef(null);
    const expenseDateEditRef = useRef(null);
    const expenseDescriptionEditRef = useRef(null);
    const expSubTotalEditRef = useRef(null);
    const expTaxEditRef = useRef(null);
    const expFileAttchRef = useRef(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { appSettings } = useSelector((state) => state.appSettings);
    const { user } = useSelector((state) => state.auth);
    const token = user?.token || null;

    const { data: expenseCategory = [], isLoading: isLoadingExpCategory } = useFetchExpCategory(token);
    const { data: clients = [], isLoading: isLoadingClient } = useGetClients(token);
    const { data: projectsNew = [], isLoading: isLoadingProject } = useGetProjects(token);
    const { data: wXCompany = [], isLoading: WXCompaniesLoading } = useWXCompanies();
    const { data: activeTeams = [], isLoading: isLoadingActiveUser } = useGetActiveTeams(token);

    const projects = projectsNew.filter((pro) => !pro.is_archived);

    const fetchExpenseData = async ({ queryKey }) => {
        const [, id, token] = queryKey;
        if (!token) {
            throw new Error("User not authenticated");
        }
        const response = await axios.get(`/api/expense/single/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    };

    const { isLoading, refetch } = useQuery({
        queryKey: ["expenseData", id, token],
        queryFn: fetchExpenseData,
        enabled: !!token,
        onSuccess: (data) => {
            setExpenseIdEdit(data.exp_id || "Exp-ID");
            setExpenseDateEdit(data.exp_date ? new Date(data.exp_date) : null);
            setExpDescriptionEdit(data.exp_description || "");
            setExpCategoryEdit(data.exp_category._id || "");
            setExpCurrencyEdit(data.exp_currency || "");
            setExpSubTotalEdit(data.exp_sub_total || "");
            setExpTaxEdit(data.exp_tax || "");
            setExpAmountEdit(data.exp_amount || 0);
            setExpIsBillableEdit(
                data.exp_is_billable !== undefined && data.exp_is_billable !== null
                    ? data.exp_is_billable
                    : true
            );
            setExpenseUserEdit(data.exp_user?._id || "");
            setExpenseClientEdit(data.exp_client?._id || "");
            setExpenseProjectEdit(data.exp_project?._id || "");
            setExpenseCompanyEdit(data.exp_wx_company?._id || "");
            setExpNoteEdit(data.exp_note || "");
            // setExpFileAttchFileNameEdit(data.exp_file_attch?.map((file) => file.name) || []);
            // setExpFileAttchFileSizeView(data.exp_file_attch?.map((file) => file.size) || []);
            setExpFileAttchFileNameEdit(data.exp_file_attch || []);
            setExpFileAttchFileSizeView(data.exp_file_attch_size || []);
        },
        onError: (err) => {
            toast.error(err.message || "Error fetching expense data", {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        },
    });

    useEffect(() => {
        dispatch(setHeaderText("Expenses"));
    }, []);

    const filteredUsers = activeTeams.filter((user) => {
        const fullName = user.first_name
            ? `${user.first_name} ${user.middle_name || ""} ${user.last_name}`
            : `${user.company_first_name ? user.company_first_name + (user.company_last_name ? ` ${user.company_last_name}` : "") : user.company_name}`;
        return fullName?.toLowerCase().includes(userSearchTerm?.toLowerCase());
    });

    // const filteredClients = clients
    //     .filter((expClient) => expClient.client_name?.toLowerCase().includes(expClientSearchTerm?.toLowerCase()))
    //     .sort((a, b) => a.client_name?.toLowerCase().localeCompare(b.client_name?.toLowerCase()));

    const filteredClients = clients && clients
        .filter((expClient) => {
            const userId = expenseUserEdit;
            const isAccManagerMatch = expClient.acc_manager && expClient.acc_manager._id?.toString() === userId;
            const isProjectManagerMatch = expClient.project_managers?.some(pm => pm._id?.toString() === userId);
            return (isAccManagerMatch || isProjectManagerMatch) &&
                expClient.client_name?.toLowerCase().includes(expClientSearchTerm && expClientSearchTerm?.toLowerCase());
        })
        .sort((a, b) => a.client_name?.toLowerCase().localeCompare(b.client_name?.toLowerCase()));

    const filteredProjects = projects
        .filter((expProject) => expProject.client_name?._id === expenseClientEdit && expProject?.project_name?.toLowerCase().includes(expProjectSearchTerm?.toLowerCase()))
        .sort((a, b) => a.project_name?.toLowerCase().localeCompare(b.project_name?.toLowerCase()));

    const filteredCompany = wXCompany
        .filter((expCompany) => expCompany.wx_company?.toLowerCase().includes(expCompanySearchTerm?.toLowerCase()))
        .sort((a, b) => a.wx_company?.toLowerCase().localeCompare(b.wx_company?.toLowerCase()));

    const filteredExpCurrencies = expCurrencyList.filter((expCurrency) =>
        `${expCurrency.currencyCode} (${expCurrency.currencyName})`.toLowerCase().includes(expCurrencySearchTerm?.toLowerCase())
    );

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 992);
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") document.activeElement.blur();
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, []);

    useEffect(() => {
        const handleClickOutsideDropdown = (event) => {
            if (expenseUserEditSelectDropdownRef.current && !expenseUserEditSelectDropdownRef.current.contains(event.target)) {
                setExpenseUserEditDropdownOpen(false);
            }
            if (expCurrencyEditDropdownRef.current && !expCurrencyEditDropdownRef.current.contains(event.target)) {
                setExpCurrencyEditDropdownOpen(false);
            }
            if (expenseClientEditDropdownRef.current && !expenseClientEditDropdownRef.current.contains(event.target)) {
                setExpClientEditDropdownOpen(false);
            }
            if (expenseCompanyEditDropdownRef.current && !expenseCompanyEditDropdownRef.current.contains(event.target)) {
                setExpCompanyEditDropdownOpen(false);
            }
            if (expenseProjectEditDropdownRef.current && !expenseProjectEditDropdownRef.current.contains(event.target)) {
                setExpProjectEditDropdownOpen(false);
            }
            if (expenseCategoryEditDropdownRef.current && !expenseCategoryEditDropdownRef.current.contains(event.target)) {
                setExpenseCategoryEditDropdownOpen(false);
            }
        };
        document.addEventListener("click", handleClickOutsideDropdown);
        return () => document.removeEventListener("click", handleClickOutsideDropdown);
    }, []);

    const ranges = [
        { label: "today", value: new Date() },
        { label: "yesterday", value: subDays(new Date(), 1) },
    ];

    const disabledDate = (date) => date > new Date();

    const handleToggleExpClientEditDropdown = () => {
        setExpClientSearchTerm("");
        setExpClientEditDropdownOpen(!expClientEditDropdownOpen);
    };

    const handleExpClientSearchInputChange = (e) => {
        setExpClientSearchTerm(e.target.value);
    };

    const handleToggleExpCompanyEditDropdown = () => {
        setExpCompanySearchTerm("");
        setExpCompanyEditDropdownOpen(!expCompanyEditDropdownOpen);
    };

    const handleExpCompanySearchInputChange = (e) => {
        setExpCompanySearchTerm(e.target.value);
    };

    const handleToggleExpenseUserEditDropdown = () => {
        setUserSearchTerm("");
        setExpenseUserEditDropdownOpen((prevOpen) => !prevOpen);
    };

    const handleSelectExpenseUserEdit = (selectedExpenseUser) => {
        setExpenseUserEdit(selectedExpenseUser);
        setExpenseClientEdit("");
        setExpenseProjectEdit("");
        setUserSearchTerm("");
        setExpenseUserEditDropdownOpen(false);
    };

    const handleExpenseUserSearchInputChange = (e) => {
        setUserSearchTerm(e.target.value);
    };

    const handleToggleExpCurrencyEditDropdown = () => {
        setExpCurrencySearchTerm("");
        setExpCurrencyEditDropdownOpen((prevOpen) => !prevOpen);
    };

    const handleExpCurrencySearchInputChange = (e) => {
        setExpCurrencySearchTerm(e.target.value);
    };

    const handleToggleExpProjectEditDropdown = () => {
        setExpProjectSearchTerm("");
        setExpProjectEditDropdownOpen(!expProjectEditDropdownOpen);
    };

    const handleExpProjectSearchInputChange = (e) => {
        setExpProjectSearchTerm(e.target.value);
    };

    const calculateTaxAmount = (subTotal, tax) => {
        const subTotalAmount = parseFloat(subTotal) || 0;
        const taxPercentage = parseFloat(tax) || 0;
        return isNaN(subTotalAmount) || isNaN(taxPercentage) ? 0 : (subTotalAmount * taxPercentage) / 100;
    };

    const calculateAmount = (subTotal, tax) => {
        const subTotalAmount = parseFloat(subTotal) || 0;
        const taxPercentage = parseFloat(tax) || 0;
        return isNaN(subTotalAmount) || isNaN(taxPercentage) ? 0 : subTotalAmount + (subTotalAmount * taxPercentage) / 100;
    };

    const allowedExtensions = ["pdf", "doc", "docx", "msword", "xls", "xlsx", "csv", "jpeg", "jpg", "png", "gif"];
    const maxFileSize = 10 * 1024 * 1024; // 10MB in bytes

    const handleExpFileAttchEditUpload = (event) => {
        const selectedFiles = Array.from(event.target.files);
        if (selectedFiles.length + expFileAttchFilesEdit.length + expFileAttchFileNameEdit.length > 10) {
            toast.error("Maximum of 10 files can be uploaded!", {
                position: "bottom-right",
                autoClose: 3500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            return;
        }

        const validFiles = selectedFiles.filter((file) => {
            const fileExtension = file.name.split(".").pop()?.toLowerCase();
            if (!allowedExtensions.includes(fileExtension)) {
                toast.error(`Invalid file format for ${file.name}. Allowed formats: pdf, doc, docx, msword, xls, xlsx, csv, jpeg, jpg, png, gif.`, {
                    position: "bottom-right",
                    autoClose: 3500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                return false;
            }
            if (file.size > maxFileSize) {
                toast.error(`File ${file.name} exceeds 10MB limit!`, {
                    position: "bottom-right",
                    autoClose: 3500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                return false;
            }
            return true;
        });

        setExpFileAttchFilesEdit((prevFiles) => [...prevFiles, ...validFiles]);
        expFileAttchRef.current.value = "";
    };

    const removeFile = (index) => {
        setExpFileAttchFilesEdit((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };

    const handleRemoveFile = (file, index) => {
        setExpFileAttchFileNameEdit((prevFiles) => prevFiles.filter((_, i) => i !== index));
        setExpFileAttchFileSizeView((prevSizes) => prevSizes.filter((_, i) => i !== index));
        setRemovedFiles((prev) => [...prev, file]);
    };

    const numberInputOnWheelPreventChange = (e) => {
        e.target.blur();
        e.stopPropagation();
        setTimeout(() => e.target.focus(), 0);
    };

    const handleExpEditSubmit = async (event) => {
        event.preventDefault();
        setExpenseDateEditIsValid(false);
        setExpenseDescriptionEditIsValid(false);
        setExpenseCategoryEditIsValid(false);
        setExpenseCurrencyEditIsValid(false);
        setExpSubTotalEditIsValid(false);
        setExpTaxEditIsValid(false);
        setExpenseUserEditIsValid(false);
        setExpenseClientEditIsValid(false);
        setExpenseCompanyEditIsValid(false);
        if (
            expenseDateEdit === null ||
            expDescriptionEdit === "" ||
            expCurrencyEdit === "" ||
            expCategoryEdit === "" ||
            expSubTotalEdit === "" ||
            isNaN(expSubTotalEdit) ||
            expTaxEdit === "" ||
            isNaN(expTaxEdit) ||
            expenseUserEdit === "" ||
            (expIsBillableEdit && expenseClientEdit === "") ||
            (!expIsBillableEdit && expenseCompanyEdit === "")
        ) {
            if (expDescriptionEdit === "") {
                setExpenseDescriptionEditIsValid(true);
                expenseDescriptionEditRef.current?.focus();
                toast.error("Expense Description cannot be empty!", {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                return;
            } else if (expenseDateEdit === null) {
                setExpenseDateEditIsValid(true);
                expenseDateEditRef.current?.focus();
                toast.error("Expense date cannot be empty!", {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                return;
            } else if (expCategoryEdit === "") {
                setExpenseCategoryEditIsValid(true);
                expenseCategoryEditRef.current?.focus();
                toast.error("Expense category cannot be empty!", {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                return;
            } else if (expCurrencyEdit === "") {
                setExpenseCurrencyEditIsValid(true);
                expenseCurrencyEditRef.current?.focus();
                toast.error("Expense currency cannot be empty!", {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                return;
            } else if (expSubTotalEdit === "" || isNaN(expSubTotalEdit)) {
                setExpSubTotalEditIsValid(true);
                expSubTotalEditRef.current?.focus();
                toast.error("Expense sub total cannot be empty!", {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                return;
            } else if (expTaxEdit === "" || isNaN(expTaxEdit)) {
                setExpTaxEditIsValid(true);
                expTaxEditRef.current?.focus();
                toast.error("Expense Tax cannot be empty!", {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                return;
            } else if (expenseUserEdit === "") {
                setExpenseUserEditIsValid(true);
                expenseUserEditRef.current?.focus();
                toast.error("User has to be selected!", {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                return;
            } else if (expIsBillableEdit && expenseClientEdit === "") {
                setExpenseClientEditIsValid(true);
                expenseClientEditRef.current?.focus();
                toast.error("Client has to be selected!", {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                return;
            } else if (!expIsBillableEdit && expenseCompanyEdit === "") {
                setExpenseCompanyEditIsValid(true);
                expenseCompanyEditRef.current?.focus();
                toast.error("Company has to be selected!", {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                return;
            }

            toast.error("Please fill all required fields!", {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            return;
        }
        setConfirmModalIsOpen(true);
    };

    const handleConfirmEditSubmit = async () => {
        const requestData = {
            exp_date: expenseDateEdit,
            exp_description: expDescriptionEdit,
            exp_category: expCategoryEdit,
            exp_currency: expCurrencyEdit,
            exp_sub_total: parseFloat(expSubTotalEdit),
            exp_tax: parseFloat(expTaxEdit),
            exp_amount: parseFloat(expAmountEdit),
            exp_is_billable: expIsBillableEdit,
            exp_user: expenseUserEdit,
            expenseClientEdit: expIsBillableEdit ? expenseClientEdit : null,
            expenseProjectEdit: expIsBillableEdit ? expenseProjectEdit : null,
            expenseCompanyEdit: !expIsBillableEdit ? expenseCompanyEdit : null,
            exp_note: expNoteEdit,
        };

        const formData = new FormData();
        if (removedFiles.length > 0) {
            requestData.removed_files = JSON.stringify(removedFiles);
        }
        if (expFileAttchFilesEdit) {
            for (let i = 0; i < expFileAttchFilesEdit.length; i++) {
                formData.append("exp_file_attch", expFileAttchFilesEdit[i]);
            }
        }
        for (let key in requestData) {
            formData.append(key, requestData[key]);
        }
        try {
            setIsSubmitLoading(true);
            await axios.put(`/api/expense/update/${id}`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });

            toast.success(`Expense ${expenseIdEdit || id} updated successfully`, {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            dispatch(setNotification(Date.now()));
            // navigate("/user/expense/overview");
            navigate(`/user/expense/view/${encodeURIComponent(encryptedId)}`);
            global.config.activityLog(window.location.href, "Expense", `Expense data of (${expenseIdEdit || id}) updated successfully`);
        } catch (error) {
            console.error(error);
            global.config.slackMessage(error.toString());
            if (error.response?.data?.status === "deleted") {
                localStorage.removeItem("user");
                dispatch(logout());
                dispatch(reset());
                dispatch(invoiceReset());
                dispatch(headerReset());
                dispatch(appSettingsReset());
                toast.error("This user is deleted!", {
                    position: "bottom-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                navigate("/");
                return;
            }
            toast.error("Something went wrong", {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } finally {
            setIsSubmitLoading(false);
            setConfirmModalIsOpen(false);
        }
    };

    if (isLoading) {
        return (
            <div className="outter-load-table">
                <ThreeDots height="80" width="80" radius="9" color="#405BFF" ariaLabel="three-dots-loading" visible={true} />
            </div>
        );
    }

    return (
        <div className="s1-containauto s1-containauto-client new-exp-create">
            <form onSubmit={handleExpEditSubmit}>
                <div className="fs-head-autoinvo">
                    <div className="bill-num-si">
                        <Link className="invoice-num-01">{expenseIdEdit}</Link>
                    </div>
                    <Link to={`/user/expense/view/${encodeURIComponent(encryptedId)}`} className="cancelbtn-link">
                        <img src={cancelImage} alt="cancel" /> Cancel
                    </Link>
                </div>
                <div className="m-edit-main exp-new-top-create">
                    <div className="edit-sheet-manual01">
                        <div className="headder-outter-res-mainu">
                            <div className="sheet-manual-header">
                                <div className="form-field-client">
                                    <label htmlFor="category" className="form-label">Category</label>
                                    {isLoadingExpCategory ? (
                                        <div className="outter-load-table">
                                            <ThreeDots height="18" width="20" radius="9" color="#405BFF" ariaLabel="three-dots-loading" visible={true} />
                                        </div>
                                    ) : (
                                        <div ref={expenseCategoryEditDropdownRef} className={`cursor ${expenseCategoryEditDropdownOpen ? "open" : ""}`}>
                                            <span
                                                id="user-select"
                                                onClick={() => setExpenseCategoryEditDropdownOpen(!expenseCategoryEditDropdownOpen)}
                                                className={`custom-dropdown-user-new custom-dropdown-select ${expenseCategoryEditIsValid ? "input-validation-error" : ""}`}
                                                ref={expenseCategoryEditRef}
                                            >
                                                {expCategoryEdit ? expenseCategory.find((exp) => exp._id === expCategoryEdit)?.exp_category_name : "Select"}
                                            </span>
                                            {expenseCategoryEditDropdownOpen && (
                                                <div className="custom-dropdown-new">
                                                    {expenseCategory.length > 0 ? (
                                                        <ul className="leave-type-list">
                                                            {expenseCategory
                                                                .slice()
                                                                .sort((a, b) => a.exp_category_name?.toLowerCase().localeCompare(b.exp_category_name?.toLowerCase()))
                                                                .map((exp) => (
                                                                    <li
                                                                        key={exp._id}
                                                                        className={expCategoryEdit === exp._id ? "selected-item" : ""}
                                                                        onClick={() => {
                                                                            setExpCategoryEdit(exp._id);
                                                                            setExpenseCategoryEditDropdownOpen(false);
                                                                        }}
                                                                    >
                                                                        {exp.exp_category_name}
                                                                    </li>
                                                                ))}
                                                        </ul>
                                                    ) : (
                                                        <div className="text-gray-500 text-sm italic">No categories available</div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                    {expenseCategoryEditIsValid && <span className="text-red-500 text-xs italic">Category is required</span>}
                                </div>
                                <div className="input-field-inof input-field-inof-new input-field-creat expense-currency-create-new">
                                    <label htmlFor="currency">Currency</label>
                                    <div ref={expCurrencyEditDropdownRef} className={`cursor ${expCurrencyEditDropdownOpen ? "open" : ""}`}>
                                        <span
                                            id="user-select"
                                            onClick={handleToggleExpCurrencyEditDropdown}
                                            className={`custom-dropdown-user-new custom-dropdown-user ${expenseCurrencyEditIsValid ? "input-validation-error" : ""}`}
                                            ref={expenseCurrencyEditRef}
                                        >
                                            {expCurrencyEdit ? expCurrencyEdit : "Select Currency"}
                                        </span>
                                        {expCurrencyEditDropdownOpen && (
                                            <div className="custom-dropdown-new">
                                                <input
                                                    type="text"
                                                    className="search-bar"
                                                    placeholder="Search..."
                                                    value={expCurrencySearchTerm}
                                                    onChange={handleExpCurrencySearchInputChange}
                                                />
                                                <ul className="currency-list">
                                                    {filteredExpCurrencies.map((c) => (
                                                        <li
                                                            key={c.currencyCode}
                                                            className={expCurrencyEdit === c.currencyCode ? "selected-item" : ""}
                                                            onClick={() => {
                                                                setExpCurrencyEdit(c.currencyCode);
                                                                setExpCurrencyEditDropdownOpen(false);
                                                            }}
                                                        >
                                                            {`${c.currencyCode} (${c.currencyName})`}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                    </div>
                                    {expenseCurrencyEditIsValid && <span className="text-red-500 text-xs italic">Currency is required</span>}
                                </div>
                                <div className="date-due-manual-edm input-field-create">
                                    <label className="invo-date-issue-tile also-for-dued-cal">Date</label>
                                    <div className="invo-date-due-cal">
                                        <div className="calender-date-due-pic">
                                            <div className="date-picker-outer date-picker-outer-all expense-create-page-date">
                                                <div className="custom-picker-icon custom-picker-icon-all">
                                                    <svg
                                                        width="1em"
                                                        height="1em"
                                                        viewBox="0 0 14 14"
                                                        fill="currentColor"
                                                        aria-hidden="true"
                                                        focusable="false"
                                                        className="rs-picker-toggle-caret rs-icon"
                                                        aria-label="calendar"
                                                    >
                                                        <path d="M1 4v8.5a.5.5 0 00.5.5H8c0-.128.049-.256.146-.354.555-.555.854-1.6.854-3.146a.5.5 0 01.621-.485l.119.03A2.623 2.623 0 0012.999 6.5V4h-12zm3-2h6V0h1v2h1.5A1.5 1.5 0 0114 3.5v3a3.623 3.623 0 01-4.015 3.603c-.064 1.245-.335 2.212-.831 2.898H12.5a.5.5 0 00.5-.5v-2a.5.5 0 011 0v2a1.5 1.5 0 01-1.5 1.5h-11a1.5 1.5 0 01-1.5-1.5v-9a1.5 1.5 0 011.5-1.5H3v-2h1v2zm5 4V5h1v1h2v1h-2v1H9V7H7v2h1v1H7v2H6v-2H4v2H3v-2H1V9h2V7H1V6h2V5h1v1h2V5h1v1h2zM6 9V7H4v2h2z"></path>
                                                    </svg>
                                                </div>
                                                <div className="custoom-icon-calender custoom-icon-calender-all non-editable-calendar">
                                                    <DatePicker
                                                        oneTap
                                                        format="dd/MM/yyyy"
                                                        ranges={ranges}
                                                        value={expenseDateEdit}
                                                        onChange={(date) => setExpenseDateEdit(date)}
                                                        placement="auto"
                                                        className="invoice-filter-top-date"
                                                        isoWeek={appSettings.weekStartDay === "Monday"}
                                                        timeZone={global.config.getTimeZone() || "Asia/Calcutta"}
                                                        disabledDate={disabledDate}
                                                    />
                                                    {expenseDateEditIsValid && <span className="text-red-500 text-xs italic">Date is required</span>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-field-client radio-sec radio-expense-create">
                                    <label htmlFor="expIsBillableEdit" className="form-label">Billable</label>
                                    <div className="radio-container">
                                        <div className="radio-option yes">
                                            <input
                                                type="radio"
                                                id="yes"
                                                name="expIsBillableEdit"
                                                checked={expIsBillableEdit}
                                                onChange={() => {
                                                    setExpIsBillableEdit(true);
                                                    setExpenseClientEdit("");
                                                    setExpenseProjectEdit("");
                                                    setExpenseCompanyEdit("");
                                                }}
                                            />
                                            <label htmlFor="yes">
                                                Yes <img src={Tick} alt="Tick" />
                                            </label>
                                        </div>
                                        <div className="radio-option no">
                                            <input
                                                type="radio"
                                                id="no"
                                                name="expIsBillableEdit"
                                                checked={!expIsBillableEdit}
                                                onChange={() => {
                                                    setExpIsBillableEdit(false);
                                                    setExpenseClientEdit("");
                                                    setExpenseProjectEdit("");
                                                    setExpenseCompanyEdit("");
                                                }}
                                            />
                                            <label htmlFor="no">
                                                No <img src={Close} alt="Close" />
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="sheed-sec-after-headem">
                            <div className="mobile-revert">
                                {isMobile && (
                                    <div className="form-field-client-mobile-billable radio-sec radio-expense-create">
                                        <label htmlFor="expIsBillableEdit" className="form-label">Billable</label>
                                        <div className="radio-container">
                                            <div className="radio-option yes">
                                                <input
                                                    type="radio"
                                                    id="yes-mobile"
                                                    name="expIsBillableEdit-mobile"
                                                    checked={expIsBillableEdit}
                                                    onChange={() => {
                                                        setExpIsBillableEdit(true);
                                                        setExpenseClientEdit("");
                                                        setExpenseProjectEdit("");
                                                        setExpenseCompanyEdit("");
                                                    }}
                                                />
                                                <label htmlFor="yes-mobile">
                                                    Yes <img src={Tick} alt="Tick" />
                                                </label>
                                            </div>
                                            <div className="radio-option no">
                                                <input
                                                    type="radio"
                                                    id="no-mobile"
                                                    name="expIsBillableEdit-mobile"
                                                    checked={!expIsBillableEdit}
                                                    onChange={() => {
                                                        setExpIsBillableEdit(false);
                                                        setExpenseClientEdit("");
                                                        setExpenseProjectEdit("");
                                                        setExpenseCompanyEdit("");
                                                    }}
                                                />
                                                <label htmlFor="no-mobile">
                                                    No <img src={Close} alt="Close" />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className="inp-sec2-with2 inp-sec2-with-client user-and-client-sec">
                                    <div className="Select Expense User">
                                        <label htmlFor="user" className="form-label">User</label>
                                        {isLoadingActiveUser ? (
                                            <div className="outter-load-table">
                                                <ThreeDots height="18" width="20" radius="9" color="#405BFF" ariaLabel="three-dots-loading" visible={true} />
                                            </div>
                                        ) : (
                                            <div ref={expenseUserEditSelectDropdownRef} className={`cursor ${expenseUserEditDropdownOpen ? "open" : ""}`}>
                                                <span
                                                    id="user-select"
                                                    onClick={handleToggleExpenseUserEditDropdown}
                                                    className={`custom-dropdown-user-new custom-dropdown-user ${expenseUserEditIsValid ? "input-validation-error" : ""}`}
                                                    ref={expenseUserEditRef}
                                                >
                                                    {expenseUserEdit ? (
                                                        activeTeams.find((user) => user._id === expenseUserEdit)?.first_name ? (
                                                            `${activeTeams.find((user) => user._id === expenseUserEdit).first_name} ${activeTeams.find((user) => user._id === expenseUserEdit).middle_name || ""} ${activeTeams.find((user) => user._id === expenseUserEdit).last_name}`
                                                        ) : (
                                                            `${activeTeams.find((user) => user._id === expenseUserEdit).company_first_name || ""} ${activeTeams.find((user) => user._id === expenseUserEdit).company_last_name || ""}`.trim() || `${activeTeams.find((user) => user._id === expenseUserEdit).company_name || ""} (Company)`
                                                        )
                                                    ) : (
                                                        "Select Expense User"
                                                    )}
                                                </span>
                                                {expenseUserEditDropdownOpen && (
                                                    <div className="custom-dropdown-new">
                                                        <input
                                                            type="text"
                                                            className="search-bar"
                                                            placeholder="Search..."
                                                            value={userSearchTerm}
                                                            onChange={handleExpenseUserSearchInputChange}
                                                        />
                                                        <ul className="client-list">
                                                            {filteredUsers
                                                                .sort((a, b) => {
                                                                    const nameA = a.first_name
                                                                        ? `${a.first_name} ${a.middle_name || ""} ${a.last_name}`
                                                                        : `${a.company_first_name || ""} ${a.company_last_name || ""}`.trim() || a.company_name;
                                                                    const nameB = b.first_name
                                                                        ? `${b.first_name} ${b.middle_name || ""} ${b.last_name}`
                                                                        : `${b.company_first_name || ""} ${b.company_last_name || ""}`.trim() || b.company_name;
                                                                    return nameA.localeCompare(nameB);
                                                                })
                                                                .map((item) => (
                                                                    <li
                                                                        key={item._id}
                                                                        className={expenseUserEdit === item._id ? "selected-item" : ""}
                                                                        onClick={() => handleSelectExpenseUserEdit(item._id)}
                                                                    >
                                                                        {item.first_name
                                                                            ? `${item.first_name} ${item.middle_name || ""} ${item.last_name}`
                                                                            : `${item.company_first_name || ""} ${item.company_last_name || ""}`.trim() || `${item.company_name} (Company)`}
                                                                    </li>
                                                                ))}
                                                        </ul>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                        {expenseUserEditIsValid && <span className="text-red-500 text-xs italic">User is required</span>}
                                    </div>
                                    {expIsBillableEdit ? (
                                        <>
                                            <div className="form-field-client">
                                                <label htmlFor="client" className="form-label">Client</label>
                                                <div ref={expenseClientEditDropdownRef} className={`custom-dropdown-user-new-outer custom-dropdown-select ${expClientEditDropdownOpen ? "open" : ""}`}>
                                                    <div
                                                        className="selected-option custom-dropdown-user-new"
                                                        ref={expenseClientEditRef}
                                                        onClick={handleToggleExpClientEditDropdown}
                                                        style={{ cursor: "pointer" }}
                                                    >
                                                        {expenseClientEdit ? clients.find((client) => client._id === expenseClientEdit)?.client_name : "Select"}
                                                    </div>
                                                    {expClientEditDropdownOpen && (
                                                        <div className="custom-dropdown-new">
                                                            <input
                                                                type="text"
                                                                className="search-bar"
                                                                placeholder="Search..."
                                                                value={expClientSearchTerm}
                                                                onChange={handleExpClientSearchInputChange}
                                                            />
                                                            {filteredClients.length > 0 ? (
                                                                <ul className="client-list">
                                                                    {filteredClients.map((client) => (
                                                                        <li
                                                                            key={client._id}
                                                                            className={expenseClientEdit === client._id ? "selected-item" : ""}
                                                                            onClick={() => {
                                                                                setExpenseClientEdit(client._id);
                                                                                setExpenseProjectEdit("");
                                                                                setExpClientEditDropdownOpen(false);
                                                                            }}
                                                                        >
                                                                            {client.client_name}
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            ) : (
                                                                <div className="text-gray-500 text-sm italic">No clients available</div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                                {expenseClientEditIsValid && <span className="text-red-500 text-xs italic">Client is required</span>}
                                            </div>
                                            {expenseClientEdit && (
                                                <div className="form-field-client">
                                                    <label htmlFor="project" className="form-label">Project</label>
                                                    <div ref={expenseProjectEditDropdownRef} className={`custom-dropdown-user-new-outer custom-dropdown-select ${expProjectEditDropdownOpen ? "open" : ""}`}>
                                                        <div
                                                            className="selected-option custom-dropdown-user-new"
                                                            ref={expenseProjectEditRef}
                                                            onClick={handleToggleExpProjectEditDropdown}
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            {expenseProjectEdit ? projects.find((project) => project._id === expenseProjectEdit)?.project_name : "Select"}
                                                        </div>
                                                        {expProjectEditDropdownOpen && (
                                                            <div className="custom-dropdown-new">
                                                                <input
                                                                    type="text"
                                                                    className="search-bar"
                                                                    placeholder="Search..."
                                                                    value={expProjectSearchTerm}
                                                                    onChange={handleExpProjectSearchInputChange}
                                                                />
                                                                {filteredProjects.length > 0 ? (
                                                                    <ul className="client-list">
                                                                        {filteredProjects.map((project) => (
                                                                            <li
                                                                                key={project._id}
                                                                                className={expenseProjectEdit === project._id ? "selected-item" : ""}
                                                                                onClick={() => {
                                                                                    setExpenseProjectEdit(project._id);
                                                                                    setExpProjectEditDropdownOpen(false);
                                                                                }}
                                                                            >
                                                                                {project.project_name}
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                ) : (
                                                                    <div className="text-gray-500 text-sm italic">No projects available</div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    ) : (
                                        <div className="form-field-client">
                                            <label htmlFor="company" className="form-label">Company</label>
                                            <div ref={expenseCompanyEditDropdownRef} className={`custom-dropdown-user-new-outer custom-dropdown-select ${expCompanyEditDropdownOpen ? "open" : ""}`}>
                                                <div
                                                    className="selected-option custom-dropdown-user-new"
                                                    ref={expenseCompanyEditRef}
                                                    onClick={handleToggleExpCompanyEditDropdown}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    {expenseCompanyEdit ? wXCompany.find((company) => company._id === expenseCompanyEdit)?.wx_company : "Select"}
                                                </div>
                                                {expCompanyEditDropdownOpen && (
                                                    <div className="custom-dropdown-new">
                                                        <input
                                                            type="text"
                                                            className="search-bar"
                                                            placeholder="Search..."
                                                            value={expCompanySearchTerm}
                                                            onChange={handleExpCompanySearchInputChange}
                                                        />
                                                        <ul className="client-list">
                                                            {filteredCompany.map((company) => (
                                                                <li
                                                                    key={company._id}
                                                                    className={expenseCompanyEdit === company._id ? "selected-item" : ""}
                                                                    onClick={() => {
                                                                        setExpenseCompanyEdit(company._id);
                                                                        setExpCompanyEditDropdownOpen(false);
                                                                    }}
                                                                >
                                                                    {company.wx_company}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                )}
                                            </div>
                                            {expenseCompanyEditIsValid && <span className="text-red-500 text-xs italic">Company is required</span>}
                                        </div>
                                    )}
                                </div>
                                <div className="detail-add-parteditmanual">
                                    <table className="invoice-table-editmanual">
                                        <thead className="the-abantant-edittxh">
                                            <tr>
                                                <th>Description</th>
                                                <th>Subtotal</th>
                                                <th>Taxes</th>
                                                <th>Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="description-manual">
                                                    <input
                                                        type="text"
                                                        value={expDescriptionEdit}
                                                        onChange={(e) => setExpDescriptionEdit(e.target.value)}
                                                        className={expenseDescriptionEditIsValid ? "input-validation-error1" : ""}
                                                        placeholder="Description"
                                                        autoComplete="off"
                                                        ref={expenseDescriptionEditRef}
                                                    />
                                                    {expenseDescriptionEditIsValid && <span className="text-red-500 text-xs italic">Description is required</span>}
                                                </td>
                                                <td className="edit-manual-costtr">
                                                    <input
                                                        type="number"
                                                        step="any"
                                                        min="0"
                                                        placeholder="Subtotal"
                                                        className={expSubTotalEditIsValid ? "input-validation-error1" : ""}
                                                        value={expSubTotalEdit}
                                                        onChange={(e) => {
                                                            const value = e.target.value ? parseFloat(e.target.value) : "";
                                                            setExpSubTotalEdit(value);
                                                            setExpAmountEdit(calculateAmount(value, expTaxEdit));
                                                        }}
                                                        autoComplete="off"
                                                        ref={expSubTotalEditRef}
                                                        onWheel={numberInputOnWheelPreventChange}
                                                    />
                                                    {expSubTotalEditIsValid && <span className="text-red-500 text-xs italic">Subtotal must be a positive number</span>}
                                                </td>
                                                <td className="editmanual-vattd">
                                                    <input
                                                        type="number"
                                                        step="any"
                                                        min="0"
                                                        placeholder="Tax %"
                                                        className={expTaxEditIsValid ? "input-validation-error1" : ""}
                                                        value={expTaxEdit}
                                                        onChange={(e) => {
                                                            const value = e.target.value ? parseFloat(e.target.value) : "";
                                                            setExpTaxEdit(value);
                                                            setExpAmountEdit(calculateAmount(expSubTotalEdit, value));
                                                        }}
                                                        autoComplete="off"
                                                        ref={expTaxEditRef}
                                                        onWheel={numberInputOnWheelPreventChange}
                                                    />
                                                    {expTaxEditIsValid && <span className="text-red-500 text-xs italic">Tax must be a non-negative number</span>}
                                                </td>
                                                <td className="editmanual-amount-tr">
                                                    <div className="amount-cell">
                                                        <span>
                                                            {expCurrencyEdit ? new Intl.NumberFormat("en-US", { style: "currency", currency: expCurrencyEdit }).format(expAmountEdit) : expAmountEdit || "0.00"}
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                {isMobile && (
                                    <div className="detail-add-parteditmanual-mobile">
                                        <div className="mobile-label-with-content">
                                            <div className="mobile-expense-label-head">Description</div>
                                            <input
                                                type="text"
                                                value={expDescriptionEdit}
                                                onChange={(e) => setExpDescriptionEdit(e.target.value)}
                                                className={expenseDescriptionEditIsValid ? "input-validation-error1" : ""}
                                                placeholder="Description"
                                                autoComplete="off"
                                                ref={expenseDescriptionEditRef}
                                            />
                                            {expenseDescriptionEditIsValid && <span className="text-red-500 text-xs italic">Description is required</span>}
                                        </div>
                                        <div className="mobile-label-with-content">
                                            <div className="mobile-expense-label-head">Subtotal</div>
                                            <input
                                                type="number"
                                                step="any"
                                                min="0"
                                                placeholder="Subtotal"
                                                className={expSubTotalEditIsValid ? "input-validation-error1" : ""}
                                                value={expSubTotalEdit}
                                                onChange={(e) => {
                                                    const value = e.target.value ? parseFloat(e.target.value) : "";
                                                    setExpSubTotalEdit(value);
                                                    setExpAmountEdit(calculateAmount(value, expTaxEdit));
                                                }}
                                                autoComplete="off"
                                                ref={expSubTotalEditRef}
                                                onWheel={numberInputOnWheelPreventChange}
                                            />
                                            {expSubTotalEditIsValid && <span className="text-red-500 text-xs italic">Subtotal must be a positive number</span>}
                                        </div>
                                        <div className="mobile-label-with-content">
                                            <div className="mobile-expense-label-head">Taxes</div>
                                            <input
                                                type="number"
                                                step="any"
                                                min="0"
                                                placeholder="Tax %"
                                                className={expTaxEditIsValid ? "input-validation-error1" : ""}
                                                value={expTaxEdit}
                                                onChange={(e) => {
                                                    const value = e.target.value ? parseFloat(e.target.value) : "";
                                                    setExpTaxEdit(value);
                                                    setExpAmountEdit(calculateAmount(expSubTotalEdit, value));
                                                }}
                                                autoComplete="off"
                                                ref={expTaxEditRef}
                                                onWheel={numberInputOnWheelPreventChange}
                                            />
                                            {expTaxEditIsValid && <span className="text-red-500 text-xs italic">Tax must be a non-negative number</span>}
                                        </div>
                                        <div className="mobile-label-with-content">
                                            <div className="mobile-expense-label-head">Amount (Subtotal + Tax)</div>
                                            <div className="amount-cell">
                                                <span>
                                                    {expCurrencyEdit ? new Intl.NumberFormat("en-US", { style: "currency", currency: expCurrencyEdit }).format(expAmountEdit) : expAmountEdit || "0.00"}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="sec-after-tab-ls-part">
                                <div className="sec-withother-and-add">
                                    <div className="other-secp1">
                                        <div className="other-head1">Other comments</div>
                                        <div className="other-head1-mobile">Notes</div>
                                        <div className="other-subhead1">
                                            <textarea
                                                id="expNoteEdit"
                                                name="expNoteEdit"
                                                placeholder="Comment here"
                                                value={expNoteEdit}
                                                onChange={(e) => setExpNoteEdit(e.target.value)}
                                                style={{ resize: "none" }}
                                            />
                                        </div>
                                    </div>
                                    <div className="file-add-p1-attachment">
                                        <div className="attachment-head">File Attachment</div>
                                        <div className="style-portion-browsetext" style={{ cursor: "pointer" }}>
                                            <label className="add-item-button-end-browse">
                                                <img src={addicoplus} alt="addicon" /> Browse
                                                <input
                                                    ref={expFileAttchRef}
                                                    type="file"
                                                    id="expFileAttchEdit"
                                                    name="expFileAttchEdit"
                                                    style={{ display: "none" }}
                                                    onChange={handleExpFileAttchEditUpload}
                                                    multiple
                                                />
                                            </label>
                                            {(expFileAttchFilesEdit.length > 0 || expFileAttchFileNameEdit.length > 0) && (
                                                <div className="upload-file-name-br">
                                                    {expFileAttchFileNameEdit.map((file, index) => (
                                                        <div key={index} className="uploaded-file-item">
                                                            <span>{file}</span>
                                                            <a onClick={() => handleRemoveFile(file, index)}>Remove</a>
                                                        </div>
                                                    ))}
                                                    {expFileAttchFilesEdit.map((file, index) => (
                                                        <div key={index} className="uploaded-file-item">
                                                            <span>{file.name}</span>
                                                            <a onClick={() => removeFile(index)}>Remove</a>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* <div className="mobile-cteate-expense-btn">
                                        <button type="submit" disabled={isSubmitLoading}><a>Update Expense</a></button>
                                    </div> */}
                                </div>

                                <div className="invo-total-specialcard">
                                    <div className="specialcard-outter">
                                        <table className="to-ino-to-special">
                                            <tr>
                                                <th className="sub-lem-tb-fisl">Subtotal</th>
                                                <td className="sub-price-tb-fisl">
                                                    {expCurrencyEdit ? new Intl.NumberFormat("en-US", { style: "currency", currency: expCurrencyEdit }).format(expSubTotalEdit || 0) : expSubTotalEdit || "0.00"}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th className="sub-vat-tb-fisl">Taxes</th>
                                                <td className="sub-vatpr-tb-fisl">
                                                    {expCurrencyEdit ? new Intl.NumberFormat("en-US", { style: "currency", currency: expCurrencyEdit }).format(calculateTaxAmount(expSubTotalEdit, expTaxEdit) || 0) : calculateTaxAmount(expSubTotalEdit, expTaxEdit) || "0.00"}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th className="sub-invoto-tb-fisl">
                                                    Amount<br />
                                                    <span>(Subtotal + Tax)</span>
                                                </th>
                                                <td className="sub-ivvoto-price-tb-fisl">
                                                    {expCurrencyEdit ? new Intl.NumberFormat("en-US", { style: "currency", currency: expCurrencyEdit }).format(expAmountEdit || 0) : expAmountEdit || "0.00"}
                                                </td>
                                            </tr>
                                        </table>
                                        <button className="largecreate-invo-btn" type="submit" disabled={isSubmitLoading}>
                                            {isSubmitLoading ? (
                                                <ThreeDots height="18" width="20" radius="9" color="white" ariaLabel="three-dots-loading" visible={true} />
                                            ) : (
                                                "Update Expense"
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                    isOpen={confirmModalIsOpen}
                    onRequestClose={() => setConfirmModalIsOpen(false)}
                    contentLabel="Confirm Expense Update"
                    style={{
                        content: {
                            height: "30%",
                            width: "30%",
                            position: "fixed",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                        },
                    }}
                >
                    <div className="modal del-pop-modal">
                        <div className="outter-modal-main delmodalicon">
                            <a onClick={() => setConfirmModalIsOpen(false)} disabled={isSubmitLoading}>
                                <img src={crssrImage} alt="Close Icon" />
                            </a>
                        </div>
                        <h2>Confirm Expense Update</h2>
                        <div>
                            <div className="modal-content-del">
                                <p>Are you sure you want to update this expense?</p>
                            </div>
                            <div className="button-container btn-2-in-modal btn-2-in-modal-delete">
                                <button className="buttons-approved" onClick={handleConfirmEditSubmit} disabled={isSubmitLoading}>
                                    {isSubmitLoading ? (
                                        <ThreeDots height="18" width="20" radius="9" color="white" ariaLabel="three-dots-loading" visible={true} />
                                    ) : (
                                        "Confirm"
                                    )}
                                </button>
                                <button className="cancel-singlebtn" onClick={() => setConfirmModalIsOpen(false)} disabled={isSubmitLoading}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
            </form>
        </div>
    );
};

export default EditExpense;
